import { BOT_SEQUENCE_CONTENT_TEMPLATES, BOT_SEQUENCE_CONTENT_TEMPLATE_LABELS, BotSequenceContentTemplate } from "@swivl-mono/types";
import { Select, SelectSize } from "@swivl-mono/ui";

const DEFAULT_OPTION = "default";

const OPTIONS = [
  { label: "Default", value: DEFAULT_OPTION },
  ...BOT_SEQUENCE_CONTENT_TEMPLATES.map((template) => ({ label: BOT_SEQUENCE_CONTENT_TEMPLATE_LABELS[template], value: template }))
];

interface TemplateSelectProps {
  value: BotSequenceContentTemplate | undefined;
  disabled: boolean;
  onChange: (next: BotSequenceContentTemplate | undefined) => void;
}

/** Asks before a template replaces wording the operator has edited. */
export function confirmTemplateSwitch(isEdited: boolean): boolean {
  return !isEdited || window.confirm("Replace the current wording with the template's wording?");
}

/** Picks the starting wording for a day's assistant-written content or email. */
export function TemplateSelect({ value, disabled, onChange }: TemplateSelectProps): React.ReactElement {
  return (
    <div className="flex items-center gap-3">
      <span className="body-xs text-grey-600">Template</span>
      <div className="w-56">
        <Select
          size={SelectSize.MEDIUM}
          hideClear
          disabled={disabled}
          selectedValues={[value ?? DEFAULT_OPTION]}
          options={OPTIONS}
          onChange={(values) => {
            const next = values[0] ?? DEFAULT_OPTION;
            onChange(next === DEFAULT_OPTION ? undefined : (next as BotSequenceContentTemplate));
          }}
        />
      </div>
    </div>
  );
}
